import { Box, Group, Stack, Text } from "@mantine/core";
import { ReactNode, isValidElement } from "react";

import { getRandomString } from "~/utils/Helper";
import { LabelValuePair } from "~/utils/Types";

const renderableOf = (value: unknown): ReactNode =>
  value === null || typeof value !== "object" || isValidElement(value)
    ? (value as ReactNode)
    : JSON.stringify(value);

const DetailPanel = ({ data }: { data: LabelValuePair[] }) => {
  const lengthOfLabels = data.map((i) => String(i.label ?? "").length);
  const maxLengthOfLabels = Math.max(...lengthOfLabels);
  const width = maxLengthOfLabels * 10;

  return (
    <Stack gap={8}>
      {data.map((i, index) => (
        <Group
          gap={0}
          wrap="nowrap"
          align="flex-start"
          key={`detail_panel_${index}_${getRandomString()}`}
        >
          <Box w={width} style={{ flexShrink: 0 }}>
            <Text size="sm" fw={600}>
              {i.label}
            </Text>
          </Box>
          <Box style={{ maxWidth: `calc(100% - ${width}px)` }}>
            {typeof i.value === "string" || typeof i.value === "number" ? (
              <Text size="sm">{i.value}</Text>
            ) : typeof i.value === "boolean" ? (
              <Text size="sm">{i.value.toString()}</Text>
            ) : Array.isArray(i.value) ? (
              <Stack gap={0}>
                {i.value.map((m) => (
                  <Text
                    size="sm"
                    key={`label_value_pair_${index}_sub_${getRandomString()}`}
                  >
                    {renderableOf(m)}
                  </Text>
                ))}
              </Stack>
            ) : (
              <Stack gap={0}>{renderableOf(i.value)}</Stack>
            )}
          </Box>
        </Group>
      ))}
    </Stack>
  );
};

export default DetailPanel;
